var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dbe4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#159b3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0660d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c7442"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#225b34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed02f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.51047625 4.42845118c0-.10618268.05952381-.25178456.13753255-.3297933l.10588728-.10588727c.07595713-.07595714.07800874-.19705637 0-.27506511l-.10588728-.10588728c-.07595713-.07595713-.13753255-.2190697-.13753255-.32979329v-.37738328c0-.10618268.08153715-.19226074.19226074-.19226074h.37738328c.10618267 0 .19226074.08153715.19226074.19226074v.37738328c0 .10618267.03515625.12194824.08835565.01554943l.20424108-.40848214c.04879748-.09759496.17803373-.17671131.27707527-.17671131h.76541791c.10422696 0 .18871962.08835565.18871962.19047619 0 .10519709-.08153716.19047619-.19226075.19047619h-.37738328c-.10618267 0-.19226073.08835565-.19226073.19047619 0 .1051971.08153715.19047619.19226073.19047619h.37738328c.10618267 0 .19226075.08192662.19226075.18684896v1.1501116c0 .10319384-.08153716.18684896-.19226075.18684896h-.37738328c-.10618267 0-.19226073-.08153715-.19226073-.19226074v-.37738327c0-.10618268.08835564-.19226075.19047619-.19226075.10519709 0 .19047619-.08835565.19047619-.19047619 0-.10519709-.08153716-.19047619-.19226075-.19047619h-.37738328c-.10618267 0-.19226074.08967809-.19226074.18871962v.76541791c0 .10422696-.08835565.18871961-.19047619.18871961-.10519709 0-.19047619-.08153715-.19047619-.19226074v-.37738327c0-.10618268-.08835565-.19226075-.19047619-.19226075-.10519709 0-.19047619.08153716-.19047619.19226075v.37738327c0 .10618268-.08835565.19226074-.19047619.19226074-.1051971 0-.19047619-.08153715-.19047619-.19226074z",
    fill: "url(#a)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.000181-.002031h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.00018117-.00203077h16.00000003l-16.00000003 11.42857137z",
    fill: "url(#d)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.00018149-.00203077 16.00000001 11.42857137h-16.00000001z",
    fill: "url(#e)",
    mask: "url(#g)",
    transform: "matrix(-1 0 0 1 16.000362 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-3.047438 4.95035h22.095238v1.52381h-22.095238z",
    fill: "url(#f)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.71446688 2.18844542-.55979547.2943019.10691142-.62334142-.45288406-.44145286.62587037-.09094429.27989774-.56713476.27989774.56713476.62587037.09094429-.45288406.44145286.10691143.62334142zm3.80952381 0-.55979547.2943019.10691142-.62334142-.45288406-.44145286.62587037-.09094429.27989774-.56713476.27989774.56713476.62587037.09094429-.45288406.44145286.10691143.62334142zm0 2.28571429-.55979547.2943019.10691142-.62334143-.45288406-.44145285.62587037-.09094429.27989774-.56713476.27989774.56713476.62587037.09094429-.45288406.44145285.10691143.62334143zm-3.80952381 0-.55979547.2943019.10691142-.62334143-.45288406-.44145285.62587037-.09094429.27989774-.56713476.27989774.56713476.62587037.09094429-.45288406.44145285.10691143.62334143zm1.9047619-1.14285714-.55979547.29430189.10691142-.62334142-.45288405-.44145285.62587037-.09094429.27989773-.56713476.27989774.56713476.62587038.09094429-.45288406.44145285.10691143.62334142z",
    fill: "#fff",
    mask: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/SB.e5fd28da58f0da05b79343c4ee780564.svg";
export { ForwardRef as ReactComponent };